import { ApolloClient } from '@apollo/client'
import gql from 'graphql-tag'
import { IUploadCredentials } from '../types'

interface ILogoUploadCredentials {
  uploadUrl: string
  filename: string
  publicCdnDomain: string
  params: IUploadCredentials
}

interface IResponse {
  admin: {
    organisation: {
      publicAwsS3UploadCredentials: ILogoUploadCredentials
    }
  }
}

const QUERY = gql`
  query organisationDetail($fileName: String!) {
    admin {
      organisation {
        id
        publicAwsS3UploadCredentials(fileName: $fileName) {
          uploadUrl
          filename
          params
          publicCdnDomain
        }
      }
    }
  }
`

export default async (
  client: ApolloClient<any>,
  fileName: string
): Promise<ILogoUploadCredentials> => {
  const response = await client.query<IResponse>({
    query: QUERY,
    variables: {
      fileName
    }
  })

  return response.data.admin.organisation.publicAwsS3UploadCredentials
}
